import { render, staticRenderFns } from "./ItemOrderDescription.vue?vue&type=template&id=708a2238&scoped=true&"
import script from "./ItemOrderDescription.vue?vue&type=script&lang=js&"
export * from "./ItemOrderDescription.vue?vue&type=script&lang=js&"
import style0 from "./ItemOrderDescription.vue?vue&type=style&index=0&id=708a2238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708a2238",
  null
  
)

export default component.exports